import Swiper from "swiper";
import { Autoplay, Navigation, Pagination, EffectFade } from "swiper/modules";
import { adjustedPx } from "../../utils/helpers";
export default class Slider {
    constructor(sliderContainer) {
        this.breakpoints = ['xs', 'sm', 'md', 'lg'];
        this.sliderContainer = sliderContainer;
        this.initSlider();
    }
    initSlidesPerView() {
        const self = this;
        const slidesPerBreakpoints = {};
        const slidesArray = [];
        const slidesPerViewData = self.sliderContainer.getAttribute('data-slides-per-view');
        if (slidesPerViewData) {
            const slidesPerView = slidesPerViewData.split(',');
            slidesPerView.forEach((slides, index) => {
                slidesArray.push(parseFloat(slides));
            });
        }
        let prevSlidePerView = 1;
        self.breakpoints.forEach((breakpoint, index) => {
            const slidesPerView = slidesArray[index] ? slidesArray[index] : prevSlidePerView;
            slidesPerBreakpoints[breakpoint] = slidesPerView;
            prevSlidePerView = slidesPerView;
        });
        return slidesPerBreakpoints;
    }
    initSlider() {
        const self = this;
        const slidesPerBreakpoints = this.initSlidesPerView();
        const slider = self.sliderContainer.querySelector('.swiper');
        const navigationNextEl = self.sliderContainer.querySelector('.swiper-button-next');
        const navigationPrevEl = self.sliderContainer.querySelector('.swiper-button-prev');
        const paginationEl = self.sliderContainer.querySelector('.swiper-pagination');
        const effect = self.sliderContainer.getAttribute('data-effect');
        const loop = self.sliderContainer.hasAttribute('data-loop');
        const autoplay = self.sliderContainer.hasAttribute('data-autoplay');
        const sm = adjustedPx(576);
        const md = adjustedPx(744);
        const lg = adjustedPx(992);
        let options = {
            modules: [],
            spaceBetween: 16,
            slidesPerView: slidesPerBreakpoints['xs'],
            loop: loop,
            autoplay: autoplay,
            breakpoints: {
                [sm]: {
                    slidesPerView: slidesPerBreakpoints['sm'],
                    spaceBetween: 16
                },
                [md]: {
                    slidesPerView: slidesPerBreakpoints['md'],
                    spaceBetween: 24
                },
                [lg]: {
                    slidesPerView: slidesPerBreakpoints['lg'],
                    spaceBetween: 24
                }
            }
        };
        if (effect === 'fade') {
            options.modules.push(EffectFade);
            options["effect"] = 'fade';
            options["fadeEffect"] = {
                crossFade: true
            };
            options["on"] = {
                slideChangeTransitionStart: function () {
                    const sliderWrapper = slider.closest('.card-gallery-slider-container');
                    const styleElements = sliderWrapper.querySelectorAll('.bg-element');
                    styleElements.forEach((el) => {
                        el.classList.add('animate-bg');
                        el.style.transform = '';
                        // rotate the element randomly between -15 and 15 degrees
                        const randomRotation = Math.random() * 30 - 15;
                        el.style.transform = `rotate(${randomRotation}deg)`;
                    });
                    console.log(styleElements);
                }
            };
        }
        if (autoplay) {
            options.modules.push(Autoplay);
        }
        if (navigationNextEl && navigationPrevEl) {
            options.modules.push(Navigation);
            options["navigation"] = {
                nextEl: navigationNextEl,
                prevEl: navigationPrevEl
            };
        }
        if (paginationEl) {
            options.modules.push(Pagination);
            options["pagination"] = {
                el: paginationEl,
                clickable: true
            };
        }
        const swiperInstance = new Swiper(slider, options);
        // Notify listeners (e.g. LazyLoad) of slide changes so they can promote
        // deferred slide assets just-in-time.
        const fireSlideChange = () => {
            self.sliderContainer.dispatchEvent(new CustomEvent('slider:slidechange', {
                detail: { swiper: swiperInstance },
            }));
        };
        swiperInstance.on('init', fireSlideChange);
        swiperInstance.on('slideChange', fireSlideChange);
        fireSlideChange();
    }
}
